import { useIntl } from "react-intl";
import { htmlLink } from "../../utils";
import { ContextualNotification } from "../Contextuals";

type Props = {
  type: string;
  hoursAfterLatestUpdateToExpire?: number;
};

export default function AssetConnectivityIssuesNotification({
  type,
  hoursAfterLatestUpdateToExpire,
}: Props) {
  const intl = useIntl();
  return (
    <ContextualNotification
      title={intl.formatMessage({
        id: `asset-connectivity-issues-${type}-info.title`,
      })}
      interactive
    >
      <div className="contextual-info">
        <p>
          {intl.formatMessage(
            { id: `asset-connectivity-issues-${type}-info.explanation` },
            {
              hours: hoursAfterLatestUpdateToExpire,
              a: htmlLink({
                href: "https://help.netilion.endress.com/hc/en-us/articles/11726912300828-Troubleshooting-Asset-or-Edge-Device-offline",
                target: "_blank",
              }),
            },
          )}
        </p>
      </div>
    </ContextualNotification>
  );
}
